




































import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user/user.store';
import { VoteSiteViewObject } from '@/types/apiServerContract';

@Component({
    components: {}
})
export default class Vote extends Vue {
	updateTimer: any = null;

	voting: boolean = false;

	get User() {
	    return UserModule.user;
	}

	async Vote(site: VoteSiteViewObject) {
	    if (this.voting) return;

	    try {
	        this.voting = true;

	        await UserModule.Vote(site);

	        window.open(site.link, '_blank');

	        this.$bvToast.toast(`After successfully voting on ${site.name}, you will be rewarded ${site.value} VP.`, {
	            title: 'Vote Verification Notice',
	            variant: 'warning',
	            solid: true
	        });
	    } finally {
	        this.voting = false;
	    }
	}

	get voteSites() {
	    return UserModule.voteSites;
	}

	get voteTimers() {
	    return UserModule.voteTimers;
	}

	GetSiteTimer(id: number) {
	    const site = this.voteTimers.find(timer => timer.site === id);
	    return site ? site.unsetTimer : 0;
	}

	GetTimeLeft(id: number) {
	    const timer = this.GetSiteTimer(id);
	    if (timer === 0) {
	        return 0;
	    }
	    const now = Math.floor(Date.now() / 1000);
	    const diff = timer - now;
	    return diff > 0 ? diff : 0;
	}

	GetTime(id: number) {
	    const timeLeft = this.GetTimeLeft(id);
	    const hours = Math.floor(timeLeft / 3600) % 24;
	    const minutes = Math.floor(timeLeft / 60) % 60;
	    const seconds = timeLeft % 60;
	    return [hours, minutes, seconds]
	        .map(v => (v < 10 ? '0' + v : v))
	        .filter((v, i) => v !== '00' || i > 0)
	        .join(':');
	}

	async created() {
	    if (!UserModule.IsLoggedIn) {
	        await UserModule.GetVoteSites();
	        await UserModule.GetVoteTimers();
	    }

	    this.updateTimer = setInterval(() => {
	        this.$forceUpdate();
	    }, 1000);
	}

	beforeDestroy() {
	    // Prevent memory leaks
	    clearInterval(this.updateTimer);
	}
}
